// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as React from "react";
import Classnames from "classnames";
import * as LottieWeb from "lottie-web";
import * as Belt_Option from "@rescript/std/lib/es6/belt_Option.js";
import * as Caml_option from "@rescript/std/lib/es6/caml_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Lottie$PrezzeeRibbon from "../../../bindings/Lottie.bs.js";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";

var constraints = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.maxWidth(BsCssJs$PrezzeeRibbon.pct(100)),
      BsCssJs$PrezzeeRibbon.maxHeight(BsCssJs$PrezzeeRibbon.pct(100))
    ]);

var Styles = {
  constraints: constraints
};

function LottieController(props) {
  var setRef = props.setRef;
  var onEnterFrame = props.onEnterFrame;
  var onLoopComplete = props.onLoopComplete;
  var onComplete = props.onComplete;
  var loop = props.loop;
  var autoplay = props.autoplay;
  var path = props.path;
  var className = props.className;
  var className$1 = className !== undefined ? className : "";
  var autoplay$1 = autoplay !== undefined ? autoplay : true;
  var loop$1 = loop !== undefined ? loop : true;
  var onComplete$1 = onComplete !== undefined ? onComplete : (function (param) {
        
      });
  var onLoopComplete$1 = onLoopComplete !== undefined ? onLoopComplete : (function (param) {
        
      });
  var onEnterFrame$1 = onEnterFrame !== undefined ? onEnterFrame : (function (param) {
        
      });
  var match = React.useState(function () {
        
      });
  var setInstance = match[1];
  var instance = match[0];
  var containerRef = React.useRef(null);
  React.useEffect((function () {
          Belt_Option.forEach(Caml_option.nullable_to_opt(containerRef.current), (function (dom) {
                  var animOptions = Lottie$PrezzeeRibbon.options(dom, "svg", path, loop$1, autoplay$1, undefined);
                  var animInst = new LottieWeb.loadAnimation(animOptions);
                  animInst.addEventListener("complete", onComplete$1);
                  animInst.addEventListener("loopComplete", onLoopComplete$1);
                  animInst.addEventListener("enterFrame", onEnterFrame$1);
                  Curry._1(setInstance, (function (param) {
                          return animInst;
                        }));
                  if (setRef !== undefined) {
                    return Curry._1(setRef, animInst);
                  }
                  
                }));
          return (function (param) {
                    if (instance !== undefined) {
                      instance.destroy();
                      return ;
                    }
                    
                  });
        }), []);
  return JsxRuntime.jsx("div", {
              ref: Caml_option.some(containerRef),
              className: Classnames([
                    constraints,
                    className$1
                  ])
            });
}

var make = LottieController;

export {
  Styles ,
  make ,
}
/* constraints Not a pure module */
